import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  stepperClass: {
    maxWidth: '35rem',
    margin: 'auto',
  },
  customStepperRoot: {
    padding: '1.5rem 0',
  },
  stepHeader: { maxWidth: '35rem', margin: 'auto', marginBottom: '1rem', marginTop: '-1rem' },
}));

export { useStyles };
